module.exports = __webpack_public_path__ + "close.png?3cf1b845b984eaa39440f51e00d08501";


//////////////////
// WEBPACK FOOTER
// ./src/assets/close.png
// module id = 29
// module chunks = 0